import { Route } from "lucide-react";

const TONE = { tour_done: "bg-violet-50 text-violet-700 border-violet-200", booked: "bg-emerald-50 text-emerald-700 border-emerald-200",
  tour_upcoming: "bg-sky-50 text-sky-700 border-sky-200", not_in_gingr: "bg-slate-50 text-slate-600 border-slate-200" };

// "Gingr journey" line: where the lead is in Gingr (tour done, booked, not in Gingr…), drives the AI draft.
export const JourneyLine = ({ j, tid }) => !j?.summary ? null : (
  <div className={`inline-flex items-center gap-1.5 text-[11px] font-semibold rounded-full border px-2.5 py-0.5 ${TONE[j.stage] || "bg-amber-50 text-amber-700 border-amber-200"}`} data-testid={tid}>
    <Route className="w-3 h-3" />Gingr: {j.summary}{j.dog ? ` · ${j.dog}` : ""}
  </div>
);
